var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep13To2Mobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 865,
    viewBox: "0 0 86 865",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.584 3.64642C16.3887 3.84173 16.3887 4.15826 16.584 4.35357L19.7659 7.53552C19.9612 7.73077 20.2778 7.73077 20.4731 7.53552C20.6683 7.34027 20.6683 7.02368 20.4731 6.82842L17.6446 3.99999L20.4731 1.17156C20.6683 0.976313 20.6683 0.659723 20.4731 0.464472C20.2778 0.26922 19.9612 0.26922 19.7659 0.464472L16.584 3.64642ZM65.0001 864L65.0001 864.5L65.0001 864ZM-6.87053e-05 864.5L65.0001 864.5L65 863.5L-6.86238e-05 863.5L-6.87053e-05 864.5ZM85.5 844L85.5 24L84.5 24L84.5 844L85.5 844ZM65 3.5L16.9375 3.49999L16.9375 4.49999L65 4.5L65 3.5ZM85.5 24C85.5 12.6782 76.3219 3.5 65 3.5L65 4.5C75.7696 4.5 84.5 13.2305 84.5 24L85.5 24ZM65.0001 864.5C76.3219 864.5 85.5 855.322 85.5 844L84.5 844C84.5 854.769 75.7696 863.5 65 863.5L65.0001 864.5Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep13To2Mobile);
export default __webpack_public_path__ + "static/media/step_13_to_2_mobile.8368274d0e1ac31bd3e0003ffc956d8b.svg";
export { ForwardRef as ReactComponent };